import {useEffect, useRef, useState} from 'react';
import WorkspaceDialog from './WorkspaceDialog';

export function DiscardEditorDialog({onKeep, onDiscard, busy=false}) {
  return <WorkspaceDialog title="Leave your unsaved changes?" onClose={onKeep} busy={busy}>
    <p>Your changes have not been saved. Stay here to finish, or discard them and continue.</p>
    <div className="tl-delete-actions"><button type="button" className="tl-btn" data-autofocus onClick={onKeep} disabled={busy}>Keep editing</button><button type="button" className="tl-btn tl-btn-danger" onClick={()=>{if(!busy)onDiscard();}} disabled={busy}>Discard changes</button></div>
  </WorkspaceDialog>;
}

export default function useEditorExit(value, busy, onCancel, onNavigationState) {
  const original = useRef(value), [confirming, setConfirming] = useState(false);
  const dirty = value !== original.current;
  useEffect(() => {onNavigationState?.({dirty, busy});}, [dirty, busy, onNavigationState]);
  useEffect(() => () => onNavigationState?.({dirty: false, busy: false}), [onNavigationState]);
  useEffect(() => {
    if (!dirty && !busy) return;
    const beforeLeave = event => {event.preventDefault(); event.returnValue = '';};
    window.addEventListener('beforeunload', beforeLeave);
    return () => window.removeEventListener('beforeunload', beforeLeave);
  }, [dirty, busy]);
  return {
    requestClose: () => {if (!busy) dirty ? setConfirming(true) : onCancel();},
    exitDialog: confirming && <DiscardEditorDialog busy={busy} onKeep={() => setConfirming(false)} onDiscard={() => {if(!busy){setConfirming(false); onCancel();}}}/>,
  };
}
